var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 18.6914C13.4905 18.6914 15.5005 16.6814 15.5005 14.1914V5.19141C15.5005 2.70141 13.4905 0.691406 11.0005 0.691406C8.51047 0.691406 6.50047 2.70141 6.50047 5.19141V14.1914C6.50047 16.6814 8.51047 18.6914 11.0005 18.6914ZM19.8655 14.1914C19.1305 14.1914 18.5155 14.7314 18.3955 15.4664C17.7805 18.9914 14.7055 21.6914 11.0005 21.6914C7.29547 21.6914 4.22047 18.9914 3.60547 15.4664C3.48547 14.7314 2.87047 14.1914 2.13547 14.1914C1.22047 14.1914 0.500468 15.0014 0.635468 15.9014C1.37047 20.4014 4.97047 23.9264 9.50047 24.5714V27.6914C9.50047 28.5164 10.1755 29.1914 11.0005 29.1914C11.8255 29.1914 12.5005 28.5164 12.5005 27.6914V24.5714C17.0305 23.9264 20.6305 20.4014 21.3655 15.9014C21.5155 15.0014 20.7805 14.1914 19.8655 14.1914Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.2eb8faf33b105bed8105c129332383c4.svg";
export { ForwardRef as ReactComponent };